export const VIEW = 'p/view';
export const CREATE = 'p/create';
export const EDIT = 'p/edit';
export const ASSESS = 'p/assess';
export const REVIEW = 'p/review';
export const ADMIN = 'p/admin';
export const SUPER = 'p/super';
